<div class="faq-item" [class.active]="open">
  <div class="faq-item__title" (click)="open = !open">
    <ng-content select="[title]"></ng-content>
    <i class="fa-solid fa-plus faq-item__title--close"></i>
  </div>
  <div class="faq-item__content">
    <div class="line"></div>
    <ng-content select="[content]"></ng-content>
  </div>
</div>
